import React, { Component } from "react";
import logo2 from "../assets/logo2.png";

class SeminarBMZ2 extends Component {
  state = { registered: {} };
  seminar = "bmz"; // ✅ Unique seminar name for backend tracking

  componentDidMount() {
    this.fetchRegistered();
  }

  fetchRegistered = async () => {
    try {
      const res = await fetch(`/api/registered?seminar=${this.seminar}`);
      const data = await res.json();
      this.setState({ registered: data });
    } catch (err) {
      console.error("Failed to fetch registered list:", err);
    }
  };

  handleRegister = async (id) => {
    const isRegistered = this.state.registered[id];

    if (isRegistered) {
      const pin = window.prompt("Enter PIN to unregister:");
      const res = await fetch("/api/unregister", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ seminar: this.seminar, id, pin }),
      });
      if (res.ok) {
        const data = await res.json();
        this.setState({ registered: data });
        alert("Unregistered successfully.");
      } else {
        alert("Incorrect PIN. Unregister cancelled.");
      }
    } else {
      const confirmRegister = window.confirm("Do you want to register?");
      if (confirmRegister) {
        const res = await fetch("/api/register", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ seminar: this.seminar, id }),
        });
        const data = await res.json();
        this.setState({ registered: data });
      }
    }
  };

  renderParticipant = (id, name) => {
    const isRegistered = this.state.registered[id];
    return (
      <div key={id}>
        <span
          onClick={() => this.handleRegister(id)}
          style={{
            color: isRegistered ? "red" : "blue", // ✅ keep blue as default
            cursor: "pointer",
            fontWeight: "500",
          }}
        >
          {id}. {name}
        </span>
      </div>
    );
  };

  render() {
    return (
      <div className="AllClasses">
        <h3>BMZ Participants Day 2</h3>
        <br />
        <br />

        {this.renderParticipant(1, "Mr.Shintaro Kon")}
        <br />
        {this.renderParticipant(2, "Mr.Kenichi Ishioka")}
        <br />
        {this.renderParticipant(3, "Mr.Shoson Thatawakorn")}
        <br />
        {this.renderParticipant(4, "Mr.Nirat Boonyasawet")}
        <br />

        <div>ASEAN AIKIDO FELLOWSHIP SEMINAR 2025 REGISTRATION SYSTEM...</div>
        <br />
        <br />
        <div>Powered by</div>
        <img className="logo2" src={logo2} alt="logo" />
        <div>New Wave Consulting Group</div>
      </div>
    );
  }
}

export default SeminarBMZ2;
